s
<script setup>
import { ref, computed } from 'vue'
import Main from './Main.vue'
import { Icon, Editable, ProfilePicture } from '@components'
import { getPrice, showDurationUnit } from '@utils'

import { useCustomizer } from '@store/customizer'
const $customizer = useCustomizer()

import { useSettings } from '@store/settings'
const $settings = useSettings()

import { useContent } from './useContent'
const { overviewContent } = useContent()

const pageDetails = ref({
    layoutTitle: `${$settings.labels.appointment?.singular} Overview`,
    // frontendTitle: 'Overview',
})

const PAYMENT = prebook_admin.settings.payment
const availablePaymentMethods = computed(() => {
    return PAYMENT.methods.filter(method => method.enabled)
})
</script>

<template>
    <Main :pageTitle="pageDetails.layoutTitle" @submit="$customizer.publish" :previous="{ name: 'customizer.form.account' }">
        <Editable v-model="customizer.booking_overview.title" :iconVisibility="false" border class="mb-5" inputClass="text-xl" :inputStyle="$customizer.titleStyle"></Editable>

        <div class="text-[#475467] text-xs font-medium capitalize">{{ $settings.labels.service?.singular }}</div>
        <div class="flex items-center gap-2 mt-1">
            <div class="text-[#101828] font-semibold text-xl" :style="$customizer.subtitleStyle">{{ overviewContent.service.name }}</div>
            <div class="flex items-center gap-1 p-[2px_10px_2px_8px] rounded-2xl bg-[#F2F4F7]">
                <Icon name="clock" size="12px" class="text-[#667085]"></Icon>
                <div class="text-[#344054] text-sm font-semibold">{{ showDurationUnit(overviewContent.service.meta.duration, overviewContent.service.meta.duration_unit, false) }}</div>
            </div>
        </div>

        <hr class="border-[#EAECF0] my-5" />

        <div class="grid grid-cols-2" v-if="$customizer.getMenuStatusById('booking_overview', `show_staff`) || $customizer.getMenuStatusById('booking_overview', `show_customer`)">
            <div v-if="$customizer.getMenuStatusById('booking_overview', `show_staff`)" class="flex items-center gap-3">
                <ProfilePicture :name="overviewContent.staff.display_name" :bgColor="overviewContent.staff.meta.color" class="w-10 h-10" />
                <div>
                    <div class="text-[#475467] text-xs font-medium capitalize">{{ $settings.labels.staff?.singular }}</div>
                    <div class="text-[#101828] font-semibold text-base" :style="$customizer.subtitleStyle">{{ overviewContent.staff.display_name }}</div>
                </div>
            </div>
            <div v-if="$customizer.getMenuStatusById('booking_overview', `show_customer`)" class="flex items-center gap-3">
                <ProfilePicture :name="overviewContent.customer.display_name" :bgColor="overviewContent.customer.meta.color" class="w-10 h-10" />
                <div>
                    <div class="text-[#475467] text-xs font-medium capitalize">{{ $settings.labels.customer?.singular }}</div>
                    <div class="text-[#101828] font-semibold text-base" :style="$customizer.subtitleStyle">{{ overviewContent.customer.display_name }}</div>
                </div>
            </div>
        </div>

        <div class="border border-[#EAECF0] bg-[#F9FAFB] p-[12px_16px] rounded-lg my-5" :class="{ '!rounded-none': !$customizer.isRounded }">
            <div class="flex items-center gap-3">
                <Icon name="calendar" size="24px" class="text-[#667085]"></Icon>
                <div class="text-[#101828] text-sm font-semibold">{{ overviewContent.date.format('DD MMM YYYY') }} <span class="font-medium ml-2">{{ overviewContent.time }}</span></div>
            </div>
            <hr class="border-[#EAECF0] my-3" v-if="overviewContent.address && $customizer.getMenuStatusById('booking_overview', 'show_address')" />
            <div class="flex items-center gap-3" v-if="overviewContent.address && $customizer.getMenuStatusById('booking_overview', 'show_address')">
                <Icon name="markerPin01" size="24px" class="text-[#667085]"></Icon>
                <div class="text-[#101828] text-sm font-medium">{{ overviewContent.address }}</div>
            </div>
        </div>

        <div v-if="$customizer.getMenuStatusById('booking_overview', 'show_payment_summary')" class="text-[#344054] text-sm flex justify-between items-center">
            <div>{{ overviewContent.service.name }}</div>
            <div>{{ getPrice(overviewContent.service.meta.price) }}</div>
        </div>

        <hr v-if="$customizer.getMenuStatusById('booking_overview', 'show_payment_summary')" class="my-3 border-[#EAECF0]" />

        <div v-if="$customizer.getMenuStatusById('booking_overview', 'show_payment_summary')" class="text-[#101828] text-base font-semibold flex justify-between items-center">
            <div>Total</div>
            <div>{{ getPrice(overviewContent.service.meta.price) }}</div>
        </div>

        <hr class="my-3 border-[#EAECF0]" v-if="$customizer.getMenuStatusById('booking_overview', 'show_payment_method') && $settings.addons.payment" />

        <div class="flex flex-col gap-4" v-if="$customizer.getMenuStatusById('booking_overview', 'show_payment_method') && $settings.addons.payment">
            <div><span class="capitalize">{{ $settings.labels?.payment?.singular }}</span> method</div>
            <!-- Radio  -->
            <div class="flex flex-col gap-2" v-for="method in availablePaymentMethods">
                <div class="flex gap-2">
                    <input type="radio" disabled :id="method.id" name="prebook-payment-method" :value="method.id" />
                    <label :for="method.id">{{ method.label }}</label>
                </div>
                <!-- <div class="bg-gray-50 border border-gray-100 px-5 py-3 rounded text-sm">
                    {{ method.description }}
                </div> -->
            </div>
        </div>

    </Main>
</template>
